import React from "react";
import Hidden from '@mui/material/Hidden';
import styles from '../../styles/pages/mobile-plan-comparison.module.scss';
import dynamic from "next/dynamic";
const Footer = dynamic(()=> import('../common/Footer'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

interface Props {
    data: any
}

class MobilePlanComparison extends React.Component<Props>{


    getMobileComponent = () => {
        return (
            <div className={`${styles.appMainWrap}`}>
                <section className={`${styles.appSection}`}>
                    <div className={`container ${styles.top}`}>
                        <h3 className={`${styles.h3}`}>8 Reasons, why customers prefer Onsitego Spills & Drops Protection Plan over <br/>
                            Flipkart Complete mobile protection and Amazon Acko Total damage protection plans.</h3>
                        <div className={`${styles.buttonWrap}`}>
                        <a className={`${styles.btn} `} target="_blank" rel="noopener noreferrer" href="/mobile-phones-damage-protection-plans" >Explore Onsitego Plans</a>
                        </div>
                    </div>            
                </section>
                <section className={`${styles.appSection} ${styles.phoneComparisons}`}>
                    <div className="container">

                    {this.props.data.map((item, index) => {
                        const title = Object.keys(item)[0]
                        const flipkart = item[title]["flipkart"]
                        const acko = item[title]["acko"]
                        const onsitego = item[title]["onsitego"]
                        const icon = item[title]["icon"]
                        return (
                            <div key={`row-${index}`} className={`${styles.compareColumn}`}>
                                <h4 className={`${styles[icon]}`}> {title} </h4>
                                <div className={`${styles.compareList}`}>
                                    <div className={`${styles.compareBrand}`}>
                                    <span className={`${styles.compareBrandImg} ${styles.flipkart}`}> </span>
                                    </div>
                                    <div className={`${styles.compareValue} ${styles[flipkart[0]]}`}>
                                    <span> {flipkart[1]} </span>
                                    </div>
                                </div>
                                <div className={`${styles.compareList}`}>
                                    <div className={`${styles.compareBrand}`}>
                                    <span className={`${styles.compareBrandImg} ${styles.acko}`}> </span>
                                    </div>
                                    <div className={`${styles.compareValue} ${styles[acko[0]]}`}>
                                    <span> {acko[1]} </span>
                                    </div>
                                </div>
                                <div className={`${styles.compareList}`}>
                                    <div className={`${styles.compareBrand}`}>
                                    <span className={`${styles.compareBrandImg} ${styles.onsitego}`}> </span>
                                    </div>
                                    <div className={`${styles.compareValue} ${styles[onsitego[0]]}`}>
                                    <span> {onsitego[1]}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    </div>
                </section>
            </div>
        )
    }

    getDesktopComponent = () => {
        return (
            <div className={`${styles.appMainWrap}`}>
                <section className={`${styles.appSection}`}>
                    <div className={`container ${styles.top}`}>
                        <h3 className={`${styles.h3}`}>8 Reasons, why customers prefer Onsitego Spills & Drops Protection Plan over <br/>
                            Flipkart Complete mobile protection and Amazon Acko Total damage protection plans.</h3>
                        <div className={`${styles.buttonWrap}`}>
                        <a className={`${styles.btn} `} target="_blank" rel="noopener noreferrer" href="/mobile-phones-damage-protection-plans" >Explore Onsitego Plans</a>
                        </div>
                    </div>
                </section>
                <section className={`${styles.appSection} ${styles.desktopComparisons}`}>
                    <div className="container">
                        <table>
                    <thead>
                    <tr>
                        <th > </th>
                        <th> <span className={`${styles.compareBrandImg} ${styles.flipkart}`}></span> </th>
                        <th> <span className={`${styles.compareBrandImg} ${styles.acko}`}></span> </th>
                        <th> <span className={`${styles.compareBrandImg} ${styles.onsitego}`}></span> </th>
                    </tr>
                    </thead>
                    <tbody>
                        {this.props.data.map((item,index) =>{

                            const title = Object.keys(item)[0]
                            const flipkart = item[title]["flipkart"]
                            const acko = item[title]["acko"]
                            const onsitego = item[title]["onsitego"]
                            const icon = item[title]["icon"]

                            return (
                            <tr key={`row-${index}`}>
                                <th className={`${styles.featureHead}`}> <span className={`${styles.featureIconTable} ${styles[icon]}`}> {title} </span> </th>
                                <th> <span className={`${styles.compareValueTable} ${styles[flipkart[0]]}`}>{flipkart[1]}</span> </th>
                                <th> <span className={`${styles.compareValueTable} ${styles[acko[0]]}`}>{acko[1]}</span> </th>
                                <th> <span className={`${styles.compareValueTable} ${styles[onsitego[0]]}`}>{onsitego[1]}</span></th>
                            </tr>
                            )
                        })}
                    </tbody>
                </table>
                    </div>
                </section>
          </div>
        )
    }

    render() {
        return (
            <div className={`${styles.appMain}`}>
                <Hidden mdUp>
                    {this.getMobileComponent()}
                </Hidden>
                <Hidden mdDown>
                    {this.getDesktopComponent()}
                    <Footer/>
                </Hidden>
            </div>
        );
    }
}

export default MobilePlanComparison;

    